// Predefined color palette for user groups
// Using Material-UI color system for consistency
export const COLOR_PALETTE = [
  {
    name: 'Blue',
    primary: '#1976d2',
    light: '#42a5f5',
    dark: '#1565c0',
    contrastText: '#ffffff',
  },
  {
    name: 'Green',
    primary: '#388e3c',
    light: '#66bb6a',
    dark: '#2e7d32',
    contrastText: '#ffffff',
  },
  {
    name: 'Orange',
    primary: '#f57c00',
    light: '#ffb74d',
    dark: '#ef6c00',
    contrastText: '#ffffff',
  },
  {
    name: 'Purple',
    primary: '#7b1fa2',
    light: '#ba68c8',
    dark: '#6a1b9a',
    contrastText: '#ffffff',
  },
  {
    name: 'Red',
    primary: '#d32f2f',
    light: '#e57373',
    dark: '#c62828',
    contrastText: '#ffffff',
  },
  {
    name: 'Teal',
    primary: '#00796b',
    light: '#4db6ac',
    dark: '#00695c',
    contrastText: '#ffffff',
  },
  {
    name: 'Indigo',
    primary: '#303f9f',
    light: '#7986cb',
    dark: '#283593',
    contrastText: '#ffffff',
  },
  {
    name: 'Pink',
    primary: '#c2185b',
    light: '#f06292',
    dark: '#ad1457',
    contrastText: '#ffffff',
  },
  {
    name: 'Amber',
    primary: '#ffa000',
    light: '#ffcc02',
    dark: '#ff8f00',
    contrastText: '#000000',
  },
  {
    name: 'Deep Purple',
    primary: '#512da8',
    light: '#9575cd',
    dark: '#4527a0',
    contrastText: '#ffffff',
  },
  {
    name: 'Cyan',
    primary: '#0097a7',
    light: '#4fc3f7',
    dark: '#00838f',
    contrastText: '#ffffff',
  },
  {
    name: 'Brown',
    primary: '#5d4037',
    light: '#8d6e63',
    dark: '#4e342e',
    contrastText: '#ffffff',
  },
]

// Get default color (first in palette)
export const getDefaultColor = () => COLOR_PALETTE[0]

// Get color by primary color value
export const getColorByPrimary = primaryColor => {
  return (
    COLOR_PALETTE.find(color => color.primary === primaryColor) ||
    getDefaultColor()
  )
}

// Get next available color (useful for auto-assigning colors)
export const getNextAvailableColor = (usedColors = []) => {
  const availableColors = COLOR_PALETTE.filter(
    color => !usedColors.includes(color.primary),
  )
  return availableColors.length > 0 ? availableColors[0] : getDefaultColor()
}
